import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { PaywallProvider } from "./components/Paywall";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Layout } from "./components/Navigation";
import { AdminLayout } from "./components/AdminLayout";
import { AuthCallback } from "./components/AuthCallback";
import { LoginPage, RegisterPage } from "./pages/AuthPages";
import { DashboardPage } from "./pages/DashboardPage";
import { PracticePage } from "./pages/PracticePage";
import { MockExamPage } from "./pages/MockExamPage";
import { SmartReviewPage } from "./pages/SmartReviewPage";
import { RoadSignsPage } from "./pages/RoadSignsPage";
import { BookmarksPage } from "./pages/BookmarksPage";
import { HazardPerceptionPage } from "./pages/HazardPerceptionPage";
import { SettingsPage } from "./pages/SettingsPage";
import { AchievementsPage } from "./pages/AchievementsPage";
import { ChallengePage } from "./pages/ChallengePage";
import { SubscriptionPage } from "./pages/SubscriptionPage";
import { HighwayCodePage } from "./pages/HighwayCodePage";
import { AdminDashboardPage } from "./pages/admin/AdminDashboardPage";
import { AdminQuestionsPage } from "./pages/admin/AdminQuestionsPage";
import { AdminUsersPage } from "./pages/admin/AdminUsersPage";
import { AdminContentPage } from "./pages/admin/AdminContentPage";
import { AdminSettingsPage } from "./pages/admin/AdminSettingsPage";
import { AdminRuleLinksPage } from "./pages/admin/AdminRuleLinksPage";
import { AdminPaywallPage } from "./pages/admin/AdminPaywallPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <PaywallProvider>
          <Layout>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              
              {/* Public challenge routes (guests can take challenges) */}
              <Route path="/challenge/:code/:view" element={<ChallengePage />} />
              <Route path="/challenge/:code" element={<ChallengePage />} />
              
              {/* Protected Routes */}
              <Route path="/challenge" element={
                <ProtectedRoute>
                  <ChallengePage />
                </ProtectedRoute>
              } />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              <Route path="/practice" element={
                <ProtectedRoute>
                  <PracticePage />
                </ProtectedRoute>
              } />
              <Route path="/mock-exam" element={
                <ProtectedRoute>
                  <MockExamPage />
                </ProtectedRoute>
              } />
              <Route path="/smart-review" element={
                <ProtectedRoute>
                  <SmartReviewPage />
                </ProtectedRoute>
              } />
              <Route path="/road-signs" element={
                <ProtectedRoute>
                  <RoadSignsPage />
                </ProtectedRoute>
              } />
              <Route path="/bookmarks" element={
                <ProtectedRoute>
                  <BookmarksPage />
                </ProtectedRoute>
              } />
              <Route path="/hazard-perception" element={
                <ProtectedRoute>
                  <HazardPerceptionPage />
                </ProtectedRoute>
              } />
              <Route path="/settings" element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              } />
              <Route path="/subscription" element={
                <ProtectedRoute>
                  <SubscriptionPage />
                </ProtectedRoute>
              } />
              <Route path="/highway-code" element={
                <ProtectedRoute>
                  <HighwayCodePage />
                </ProtectedRoute>
              } />
              <Route path="/practice/rule/:sectionId/:ruleId" element={
                <ProtectedRoute>
                  <PracticePage />
                </ProtectedRoute>
              } />
              <Route path="/achievements" element={
                <ProtectedRoute>
                  <AchievementsPage />
                </ProtectedRoute>
              } />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboardPage />} />
                <Route path="questions" element={<AdminQuestionsPage />} />
                <Route path="users" element={<AdminUsersPage />} />
                <Route path="content" element={<AdminContentPage />} />
                <Route path="settings" element={<AdminSettingsPage />} />
                <Route path="rule-links" element={<AdminRuleLinksPage />} />
                <Route path="paywall" element={<AdminPaywallPage />} />
              </Route>
              
              {/* Default Redirect */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" />
          </PaywallProvider>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
